import { render, staticRenderFns } from "./NewMediaReport.vue?vue&type=template&id=0bec1ad3&scoped=true&lang=pug"
import script from "./NewMediaReport.js?vue&type=script&lang=js&external"
export * from "./NewMediaReport.js?vue&type=script&lang=js&external"
import style0 from "./NewMediaReport.vue?vue&type=style&index=0&id=0bec1ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bec1ad3",
  null
  
)

export default component.exports